/**
 * Renders an generic hidden input field
 * @returns {JSX.Element} The basic text input.
 * @param {any} props given by caller
 */
import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

const ReactSelect = props => {
    const [menuMinWidth, setMenuMinWidth] = useState(0);
    // Calculate widest option
    useEffect(() => {
        if (!props.options) return;

        const tempSpan = document.createElement('span');
        tempSpan.style.visibility = 'hidden';
        tempSpan.style.position = 'absolute';
        tempSpan.style.whiteSpace = 'nowrap';
        document.body.appendChild(tempSpan);

        let maxWidth = 0;
        props.options.forEach(f => {
            tempSpan.innerText = f?.label;
            const width = tempSpan.getBoundingClientRect().width;
            if (width > maxWidth) maxWidth = width;
        });
        document.body.removeChild(tempSpan);

        const calculatedWidth = maxWidth - 30;
        const maxWithProps = props.maxWidth > 200 ? props.maxWidth : 200;
        setMenuMinWidth(Math.min(calculatedWidth, maxWithProps));
    }, [props.options]);

    return (
        <div className="mfx-react-select" id={props.id}>
            <CreatableSelect
                classNamePrefix={props.classNamePrefix}
                isValidNewOption={(inputValue, selectValue, selectOptions) => {
                    if (props.disableCreate) return false;
                    if (!inputValue) return false;

                    return !selectOptions?.some(option => option?.label?.toLowerCase() === inputValue.toLowerCase());
                }}
                onChange={props.onChange}
                onCreateOption={props.onCreateOption}
                options={props.options}
                value={props.value}
                defaultValue={props.defaultValue}
                isMulti={props.isMulti}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                name={props.name}
                styles={{
                    control: base => ({
                        ...base,
                        fontSize: '0.9rem',
                        borderRadius: 0,
                        borderColor: 'var(--borderColor)',
                        boxShadow: 'none',
                        backgroundColor: 'var(--bgColor)',
                        color: 'var(--fontColor)',
                        '&:hover': {
                            borderColor: 'var(--borderColor)',
                        },
                    }),
                    singleValue: base => ({
                        ...base,
                        color: 'var(--fontColor)',
                        minWidth: menuMinWidth,
                    }),
                    menuPortal: (base, state) => ({
                        ...base,
                        zIndex: 10000,
                        minWidth: menuMinWidth,
                    }),
                    menu: (base, state) => ({
                        ...base,
                        backgroundColor: 'var(--bgColor)',
                    }),
                    menuList: base => ({
                        ...base,
                        maxHeight: 150,
                        overflowY: 'auto',
                    }),
                    option: (base, state) => ({
                        ...base,
                        color: 'var(--fontColor)',
                        backgroundColor: state.isSelected ? '#27466b' : state.isFocused ? 'var(--pageBg)' : 'var(--bgColor)',
                        '&:hover': {
                            backgroundColor: state.isSelected ? '#27466b' : 'var(--pageBg)',
                        },
                    }),
                }}
            />
        </div>
    );
};

export default ReactSelect;
